import type { HTMLProps } from "react";

import * as styles from "./BasicInput.styles";

interface Props extends HTMLProps<HTMLInputElement> {
  /**
   * Change the size of the input
   *
   * @default normal
   */
  isSize?: "small" | "normal" | "large";
  /**
   * Label used for accessibility labelling purposes
   *
   * @required
   */
  label: string;
}

const BasicInput = ({ label, isSize, disabled, ...rest }: Props) => {
  const css = [styles.input, styles.sizes[isSize], disabled && styles.disabled];

  return <input css={css} aria-label={label} {...rest} />;
};

BasicInput.defaultProps = {
  isSize: "normal",
};

export { BasicInput };
export type { Props as BasicInputProps };
